import CustomNavigationEvent from "../../components/customEvents/CustomNavigationEvent";
import { useInitCustomerEvents } from "../../providers/events/hooks";

const CustomEventsProvider = function () {
  // Conditionally enable some events to avoid adding them for customer that don't need them
  const { enableCustomNavigationEvent } = useInitCustomerEvents();

  return <>{enableCustomNavigationEvent && <CustomNavigationEvent />}</>;
};

export default CustomEventsProvider;
